module.exports = __webpack_public_path__ + "images/product_pickle_2.fe4fe6e0.jpg";